export const initState = {
  alertMessage: {
    type: "error",
    message: "",
    openAlert: false,
  },
  loading: false,
  customerCurrentTab: 0,
  customerManageCurrentTab: 0,
  employeeCurrentTab: 0,
  rentRequestCurrentTab: 0,
  returnRequestCurrentTab: 0,
  rentDetailCurrentTab: 0,
  returnDetailCurrentTab: 0,
  deviceDetailCurrentTab: 0,
  inventoryDetailCurrentTab: 0,
  priceListCurrentTab: 0,
  maintainCurrentTab: 0,
  maintainDetailCurrentTab: 0,
  settingCurrentTab: 0,
  manageDeviceCurrentTab: 0,
  urlImage: "",
  isStickyBtn: false,
  unReadCount: {
    YEU_CAU_THUE_MAY: {
      YEU_CAU_MOI: 0,
      HOP_DONG_TAM_UNG: 0,
      KIEM_KHO: 0,
      VAN_CHUYEN: 0,
      LAP_DAT_THANH_TOAN: 0,
      HOAN_TAT: 0,
      DA_HUY: 0,
      TOTAL: 0,
    },
    YEU_CAU_TRA_MAY: {
      YEU_CAU_MOI: 0,
      DANG_XU_LY: 0,
      DANH_GIA_THIET_BI: 0,
      HOAN_TAT: 0,
      DA_HUY: 0,
      TOTAL: 0,
    },
    YEU_CAU_BOI_THUONG: 0,
  },
};
